export const GLOBAL_STATE = 'VacancyPosition'

export const VACANCY_POSITION_LIST = 'VACANCY_POSITION_LIST' as const
export const VACANCY_POSITION_ALL = 'VACANCY_POSITION_ALL' as const
export const VACANCY_POSITION_CREATE = 'VACANCY_POSITION_CREATE' as const
export const VACANCY_POSITION_DELETE = 'VACANCY_POSITION_DELETE' as const
export const VACANCY_POSITION = 'VACANCY_POSITION' as const
export const VACANCY_POSITION_ACTIVATE = 'VACANCY_POSITION_ACTIVATE' as const
export const VACANCY_POSITION_OPEN = 'VACANCY_POSITION_OPEN' as const
export const VACANCY_POSITION_CLOSE = 'VACANCY_POSITION_CLOSE' as const
